import React from "react";
import VideoBanner from "../components/VideoBanner";
import video from "../assets/images/video2.mp4";
import Slogan from "../components/Slogan";
import EmbeddedVideo from "../components/EmbeddedVideo";
import Customers from "../components/Customers";
import ImageList from "../components/ImageList";
import Manager from "../components/Manager";
import RecordAndBenefit from "../components/RecordAndBenefit";
import {useSettingState} from "../context/SettingContext";
import configs from "../utils/config.json";
import {useDataState} from "../context/DataContext";

const AboutUs = (props) => {
    const setting = useSettingState();
    const data = useDataState();

    return <>
        <VideoBanner video={`${configs.server.Storage}/${setting.state.aboutUs.videoBanner.video}`}
                     showButton1={setting.state.aboutUs.videoBanner.hasButton1}
                     showButton2={setting.state.aboutUs.videoBanner.hasButton2}
                     title1={setting.state.aboutUs.videoBanner.title}
                     title2={setting.state.aboutUs.videoBanner.description}
                     Button1Text={setting.state.aboutUs.videoBanner.Button1Text}
                     Button1Link={setting.state.aboutUs.videoBanner.Button1Link}
                     Button2Text={setting.state.aboutUs.videoBanner.Button2Text}
                     Button2Link={setting.state.aboutUs.videoBanner.Button2Link}/>
        <Slogan  title={setting.state.aboutUs.embeddedVideo.title} description={setting.state.aboutUs.embeddedVideo.description}/>
        <EmbeddedVideo video={`${configs.server.Storage}/${setting.state.aboutUs.embeddedVideo.video}`}/>
        <Customers title={setting.state.home.customersTitle} content={data.state.customer.slice(0, 5)}/>
        <ImageList title={setting.state.aboutUs.person.title} slogan={setting.state.aboutUs.person.slogan} imgs={data.state.person}/>
        <Manager img={`${configs.server.Storage}/${setting.state.aboutUs.manager.img}`} message={setting.state.aboutUs.manager.message} name={setting.state.aboutUs.manager.name} position={setting.state.aboutUs.manager.position}/>
        <RecordAndBenefit img={`${configs.server.Storage}/${setting.state.aboutUs.infoBanner.img}`} records={setting.state.aboutUs.infoBanner.record} benefit={setting.state.aboutUs.infoBanner.benefit}/>
    </>;
};

export default AboutUs;